import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const materialComparisonUiNodeSpec: NodeSpec<NodeCfg<'materialComparison'>> = {
    requiredSockets: 'all',
    cfg: () => ({
        disabled: false,
        kind: 'materialComparison',
        id: getUID(),
        width: 340,
        controlValues: {
            comparisonCfg: {
                operation: '=',
                materialModelId: '',
                kind: 'materialModel',
            },
        },
    }),
    controls: nodeCfg => ({
        comparisonCfg: defineControlOpts({
            cfg: { kind: 'materialComparisonCfg' },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.comparisonCfg,
        }),
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        materialId: { socket: 'string', label: 'Material ID' },
    }),
    kindLabel: 'Material Comparison',
    nodeCategory: 'material',
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
        result: { socket: 'boolean', label: 'Result' },
    }),
    validator: () => true,
};
